<template>
      <div class="custom-info-label info--text mr-2">
        <template v-if="isUnlimited">
          <v-icon
            size="12"
            class="info--text"
          >$infiniteIcon</v-icon>
          <span class="ml-1">{{ $t('heading.instance.backups.usage.unlimited') }}</span>
        </template>
        <template v-else>
          {{ displayText }}
        </template>
        <v-tooltip
          open-delay="150"
          bottom
          transition="custom-tooltip"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-on="on"
              v-bind="attrs"
              size="12"
              class="ml-1 info--text"
            >$infoCircle</v-icon>
          </template>
          {{ tooltipText }}
        </v-tooltip>
      </div>
</template>

<script>
export default {
  name: "BackupsUsageItem",
  props: {
    item: Object
  },
  computed: {
    isUnlimited() {
      return this.item.data.max === null || this.item.data.max === undefined;
    },
    displayText() {
      return `${this.totalText} / ${this.maxText}`;
    },
    tooltipText() {
      if (this.isUnlimited) {
        return this.$t('heading.instance.backups.usage.unlimited.tooltip');
      }

      return this.$t(`heading.instance.backups.usage.${this.item.name}.tooltip`);
    },
    totalText() {
      if (this.$i18next.exists(`heading.instance.backups.usage.${this.item.name}.total.suffix`)) {
        return this.item.data.total + ' '+ this.$i18next.t(`heading.instance.backups.usage.${this.item.name}.total.suffix`);
      }

      if (this.$i18next.exists(`heading.instance.backups.usage.${this.item.name}.total.suffix_one`)) {
        return this.item.data.total + ' '+ this.$i18next.t(`heading.instance.backups.usage.${this.item.name}.total.suffix`, {count: this.item.data.total});
      }

      return this.item.data.total;
    },
    maxText() {
      if (this.$i18next.exists(`heading.instance.backups.usage.${this.item.name}.max.suffix`)) {
        return this.item.data.max + ' '+ this.$i18next.t(`heading.instance.backups.usage.${this.item.name}.max.suffix`);
      }

      if (this.$i18next.exists(`heading.instance.backups.usage.${this.item.name}.max.suffix_one`)) {
        return this.item.data.max + ' '+ this.$i18next.t(`heading.instance.backups.usage.${this.item.name}.max.suffix`, {count: this.item.data.max});
      }

      return this.item.data.max;
    },
  },
}
</script>



<style scoped lang="scss">

</style>
